<template>
  <div class="campaign-details-section">
      <div class="data-title" v-if="!headerHide">
        <span>campaign details</span>
        <small>
          <a v-if="relatedCampaignId" :href="`/campaigns/${relatedCampaignId}`">
            {{relatedCampaignTypeText}}
          </a>
        </small>
      </div>

      <table class="unstriped">
        <tbody>
          <tr class="campaign-created-row">
            <td>campaign created</td>
            <td class="text-right">{{formattedCreatedAt}}</td>
          </tr>
          <tr class="campaign-created_by-row">
            <td>created by</td>
            <td class="text-right">{{createdBy}}</td>
          </tr>
          <tr class="campaign-scheduled-row">
            <td>scheduled for</td>
            <td class="text-right">{{scheduledFor}}</td>
          </tr>
          <tr class="campaign-review_status-row">
            <td>review status</td>
            <td class="text-right" :class="reviewStatus">{{reviewStatus}}</td>
          </tr>
          <tr class="campaign-email-sent-row">
            <td>emails sent</td>
            <td class="text-right">{{emailSentCount}}</td>
          </tr>
          <tr class="campaign-credits-used-row">
            <td>credits used</td>
            <td class="text-right">{{creditsUsed}}</td>
          </tr>
          <tr class="campaign-mms-row">
            <td>stashboard media</td>
            <td class="text-right attachment_count">{{hasStashboardMedia}}</td>
          </tr>
          <tr v-if="haveClassicCampaignDisabledAndNotificationMmsEnabled">
            <td>notification image</td>
            <td class="text-right">{{hasNotificationImage}}</td>
          </tr>
          <tr class="campaign-audio-row">
            <td>voice message</td>
            <td class="text-right attachment_count">{{hasAudio}}</td>
          </tr>
          <tr v-if="currentMerchant.show_brands" class="campaign-mms-row">
            <td>sponsored</td>
            <td class="text-right attachment_count">{{hasAd}}</td>
          </tr>
          <tr class="campaign-sent-at-row">
            <td>sent at</td>
            <td class="text-right">{{sendAtStatus}}</td>
          </tr>
          <tr class="campaign-cancelled-row">
            <td>cancelled</td>
            <td class="text-right">
              <modal v-if="showCancelPopup" :showClose="false" :wrapperClasses="clicks-modal">
                <br />
                <h3 slot="header" class="title">are you sure you want to cancel this campaign?</h3>
                <div slot="action">
                  <button class="button action-button modal-click-action button-wrapper close" @click="showCancelPopup = false">no</button>
                  <a :href="`/campaigns/${campaignItem.id}`" rel="nofollow" data-method="delete" class="button modal-click-action"><strong>yes</strong></a>
                </div>
              </modal>
              <a v-if="hasAbilityToShowCancellationModal" class="cancel" rel="nofollow" @click="showCancelPopup = true">cancel campaign</a>

              <span>{{ campaignCountdown }}</span>
              <span v-if="!hasAbilityToShowCancellationModal">{{cancelledStatus}}</span>
            </td>
          </tr>
        </tbody>
      </table>

  </div>
</template>


<script>
  import { mapGetters, mapState } from 'vuex'
  import moment from 'moment-timezone'
  import UserAbilitiesMixin from '../../mixins/UserAbilitiesMixin'
  import Modal from '../../components/shared/Modal'

  export default {
    props: {
      campaignItem: Object,
      creditsUsed: {
        type: [Number, String],
        default: 'calculating'
      },
      reviewStatus: String,
      headerHide: Boolean,
    },

    components: {
      Modal
    },

    name: 'CampaignDetails',

    mixins: [UserAbilitiesMixin],

    data() {
      return {
        backupIds: null,
        campaignLoading: true,
        cancellable: false,
        cancelledAt: null,
        createdAt: null,
        emailSentCount: null,
        hasAd: null,
        hasAudio: null,
        hasStashboardMedia: null,
        hasNotificationImage: null,
        parentId: null,
        sendAt: null,
        timeSent: null,
        createdBy: null,
        secondsToSend: null,
        showCancelPopup: false,
        timerId: null
      }
    },

    methods: {
      configureDetails(item) {
        this.backupIds = item.backup_campaign_ids || []
        this.cancellable = item.cancellable
        this.cancelledAt = item.cancelled_at
        this.createdAt = item.created_at
        this.emailSentCount = item.email_sent
        this.hasAd = item.has_ad ? 'yes' : 'no'
        this.hasStashboardMedia = item?.stashboard_media?.length ? 'yes' : 'no'
        this.hasNotificationImage = item.template_image ? "yes" : "no"
        this.hasAudio = item?.audio?.length ? 'yes' : 'no'
        this.parentId = item.parent_id
        this.sendAt = item.send_at
        this.timeSent = item.time_sent
        this.reviewStatus = item.review_status
        this.createdBy = item.created_by
        this.secondsToSend = item.remained_seconds_to_send
        this.$emit('primarySecondary', this.parentId, this.backupIds)
      },

      formatToMerchantTimeZone(timeToFormat) {
        if (timeToFormat && !!this.currentMerchant && !!moment.tz) {
          const utcTime = moment.utc(timeToFormat),
            momentTzDate = utcTime.tz(this.currentMerchant.merchant_time_zone),
            dateFormatted = momentTzDate ? momentTzDate.format('MM/DD/YY') : '--',
            timeFormatted = momentTzDate ? momentTzDate.format('h:mma') : '--'
          return `${dateFormatted} at ${timeFormatted}`
        }
      },

      startCountdown() {
        if (!this.timerId) {
          this.timerId = setInterval(() => {
            this.secondsToSend -= 1
            if (this.secondsToSend === 0) {
              clearInterval(this.timerId)
              this.cancellable = false
            }
          }, 1000)
        }
      }
    },

    created() {
      !!this.campaignItem && this.configureDetails(this.campaignItem)
    },

    computed: {
      cancelledStatus: function () {
        return this.cancelledAt ? this.formatToMerchantTimeZone(this.cancelledAt) : 'no'
      },

      formattedCreatedAt: function() {
        return this.formatToMerchantTimeZone(this.createdAt)
      },

      haveClassicCampaignDisabledAndNotificationMmsEnabled(){
        return !this.classicCampaignsEnabled && this.hasNotificationMmsMetaEnabled
      },

      relatedCampaignId: function() {
        const firstBackupId = this.backupIds?.length ? this.backupIds[0] : null
        return this.parentId || firstBackupId
      },

      relatedCampaignTypeText: function() {
        let relatedCampaignType = !!this.parentId ? 'primary' : this.backupIds?.length ? 'backup' : 'related'
        return `view ${relatedCampaignType} campaign`
      },

      sendAtStatus: function () {
        let sendAtFormatted = this.formatToMerchantTimeZone(this.timeSent)
        if (!this.sendAt && !this.timeSent && !this.cancelledAt) { sendAtFormatted = 'sending'}
        if (this.sendAt && !this.timeSent && !this.cancelledAt) { sendAtFormatted = 'scheduled for later'}
        if (this.cancelledAt) { sendAtFormatted = '--'}
        return sendAtFormatted
      },

      scheduledFor: function () {
        return this.sendAt ? this.formatToMerchantTimeZone(this.sendAt) : 'sent immediately'
      },

      campaignCountdown: function() {
        if (this.secondsToSend) {
          const minutes = Math.floor(this.secondsToSend / 60)
          const seconds = (new Array(3).join('0') + (this.secondsToSend % 60)).slice(-2);
          return `(${minutes}:${seconds})`
        }
      },

      hasAbilityToShowCancellationModal: function() {
        return this.cancellable && this.hasAccess(this.userAbilitiesValue, 'CAMPAIGNS_CREATE');
      },

      ...mapGetters([
        'classicCampaignsEnabled',
        'hasNotificationMmsMetaEnabled',
        'userAbilitiesValue'
      ]),

      ...mapState([
        'currentMerchant'
      ]),
    },

    watch: {
      campaignItem: function () {
        !!this.campaignItem && this.configureDetails(this.campaignItem)
        if (this.campaignItem.remained_seconds_to_send) this.startCountdown();
      }
    }
  }
</script>
